// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

export class AllBanksOutOfServiceResponse implements flatbuffers.IUnpackableObject<AllBanksOutOfServiceResponseT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): AllBanksOutOfServiceResponse {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsAllBanksOutOfServiceResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksOutOfServiceResponse,
  ): AllBanksOutOfServiceResponse {
    return (obj || new AllBanksOutOfServiceResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsAllBanksOutOfServiceResponse(
    bb: flatbuffers.ByteBuffer,
    obj?: AllBanksOutOfServiceResponse,
  ): AllBanksOutOfServiceResponse {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new AllBanksOutOfServiceResponse()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  bankName(): string | null;
  bankName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  bankName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  liftName(): string | null;
  liftName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  liftName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  floorName(): string | null;
  floorName(optionalEncoding: flatbuffers.Encoding): string | Uint8Array | null;
  floorName(optionalEncoding?: any): string | Uint8Array | null {
    const offset = this.bb!.__offset(this.bb_pos, 8);
    return offset ? this.bb!.__string(this.bb_pos + offset, optionalEncoding) : null;
  }

  date(): string;
  date(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  date(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 10);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  availability(): string;
  availability(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  availability(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 12);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  serviceMode(): string;
  serviceMode(optionalEncoding: flatbuffers.Encoding): string | Uint8Array;
  serviceMode(optionalEncoding?: any): string | Uint8Array {
    const offset = this.bb!.__offset(this.bb_pos, 14);
    return this.bb!.__string(this.bb_pos + offset, optionalEncoding);
  }

  bankId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 16);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  liftId(): number {
    const offset = this.bb!.__offset(this.bb_pos, 18);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  position(): number {
    const offset = this.bb!.__offset(this.bb_pos, 20);
    return offset ? this.bb!.readInt16(this.bb_pos + offset) : 0;
  }

  static startAllBanksOutOfServiceResponse(builder: flatbuffers.Builder) {
    builder.startObject(9);
  }

  static addBankName(builder: flatbuffers.Builder, bankNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(0, bankNameOffset, 0);
  }

  static addLiftName(builder: flatbuffers.Builder, liftNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, liftNameOffset, 0);
  }

  static addFloorName(builder: flatbuffers.Builder, floorNameOffset: flatbuffers.Offset) {
    builder.addFieldOffset(2, floorNameOffset, 0);
  }

  static addDate(builder: flatbuffers.Builder, dateOffset: flatbuffers.Offset) {
    builder.addFieldOffset(3, dateOffset, 0);
  }

  static addAvailability(builder: flatbuffers.Builder, availabilityOffset: flatbuffers.Offset) {
    builder.addFieldOffset(4, availabilityOffset, 0);
  }

  static addServiceMode(builder: flatbuffers.Builder, serviceModeOffset: flatbuffers.Offset) {
    builder.addFieldOffset(5, serviceModeOffset, 0);
  }

  static addBankId(builder: flatbuffers.Builder, bankId: number) {
    builder.addFieldInt16(6, bankId, 0);
  }

  static addLiftId(builder: flatbuffers.Builder, liftId: number) {
    builder.addFieldInt16(7, liftId, 0);
  }

  static addPosition(builder: flatbuffers.Builder, position: number) {
    builder.addFieldInt16(8, position, 0);
  }

  static endAllBanksOutOfServiceResponse(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 10); // date
    builder.requiredField(offset, 12); // availability
    builder.requiredField(offset, 14); // service_mode
    return offset;
  }

  static createAllBanksOutOfServiceResponse(
    builder: flatbuffers.Builder,
    bankNameOffset: flatbuffers.Offset,
    liftNameOffset: flatbuffers.Offset,
    floorNameOffset: flatbuffers.Offset,
    dateOffset: flatbuffers.Offset,
    availabilityOffset: flatbuffers.Offset,
    serviceModeOffset: flatbuffers.Offset,
    bankId: number,
    liftId: number,
    position: number,
  ): flatbuffers.Offset {
    AllBanksOutOfServiceResponse.startAllBanksOutOfServiceResponse(builder);
    AllBanksOutOfServiceResponse.addBankName(builder, bankNameOffset);
    AllBanksOutOfServiceResponse.addLiftName(builder, liftNameOffset);
    AllBanksOutOfServiceResponse.addFloorName(builder, floorNameOffset);
    AllBanksOutOfServiceResponse.addDate(builder, dateOffset);
    AllBanksOutOfServiceResponse.addAvailability(builder, availabilityOffset);
    AllBanksOutOfServiceResponse.addServiceMode(builder, serviceModeOffset);
    AllBanksOutOfServiceResponse.addBankId(builder, bankId);
    AllBanksOutOfServiceResponse.addLiftId(builder, liftId);
    AllBanksOutOfServiceResponse.addPosition(builder, position);
    return AllBanksOutOfServiceResponse.endAllBanksOutOfServiceResponse(builder);
  }

  unpack(): AllBanksOutOfServiceResponseT {
    return new AllBanksOutOfServiceResponseT(
      this.bankName(),
      this.liftName(),
      this.floorName(),
      this.date(),
      this.availability(),
      this.serviceMode(),
      this.bankId(),
      this.liftId(),
      this.position(),
    );
  }

  unpackTo(_o: AllBanksOutOfServiceResponseT): void {
    _o.bankName = this.bankName();
    _o.liftName = this.liftName();
    _o.floorName = this.floorName();
    _o.date = this.date();
    _o.availability = this.availability();
    _o.serviceMode = this.serviceMode();
    _o.bankId = this.bankId();
    _o.liftId = this.liftId();
    _o.position = this.position();
  }

  unpackFields(...fields: string[]): AllBanksOutOfServiceResponseT {
    const t = new AllBanksOutOfServiceResponseT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("bank_name")) {
      t.bankName = this.bankName();
    }
    if (fieldSet.has("lift_name")) {
      t.liftName = this.liftName();
    }
    if (fieldSet.has("floor_name")) {
      t.floorName = this.floorName();
    }
    if (fieldSet.has("date")) {
      t.date = this.date();
    }
    if (fieldSet.has("availability")) {
      t.availability = this.availability();
    }
    if (fieldSet.has("service_mode")) {
      t.serviceMode = this.serviceMode();
    }
    if (fieldSet.has("bank_id")) {
      t.bankId = this.bankId();
    }
    if (fieldSet.has("lift_id")) {
      t.liftId = this.liftId();
    }
    if (fieldSet.has("position")) {
      t.position = this.position();
    }
    return t;
  }
}

export class AllBanksOutOfServiceResponseT implements flatbuffers.IGeneratedObject {
  constructor(
    public bankName: string | Uint8Array | null = null,
    public liftName: string | Uint8Array | null = null,
    public floorName: string | Uint8Array | null = null,
    public date: string | Uint8Array | null = null,
    public availability: string | Uint8Array | null = null,
    public serviceMode: string | Uint8Array | null = null,
    public bankId: number = 0,
    public liftId: number = 0,
    public position: number = 0,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.date === null || this.date === undefined) {
      throw new Error('Required field "date" is not set');
    }
    if (this.availability === null || this.availability === undefined) {
      throw new Error('Required field "availability" is not set');
    }
    if (this.serviceMode === null || this.serviceMode === undefined) {
      throw new Error('Required field "service_mode" is not set');
    }
    const bankName = this.bankName !== null ? builder.createString(this.bankName!) : 0;
    const liftName = this.liftName !== null ? builder.createString(this.liftName!) : 0;
    const floorName = this.floorName !== null ? builder.createString(this.floorName!) : 0;
    const date = this.date !== null ? builder.createString(this.date!) : 0;
    const availability = this.availability !== null ? builder.createString(this.availability!) : 0;
    const serviceMode = this.serviceMode !== null ? builder.createString(this.serviceMode!) : 0;

    return AllBanksOutOfServiceResponse.createAllBanksOutOfServiceResponse(
      builder,
      bankName,
      liftName,
      floorName,
      date,
      availability,
      serviceMode,
      this.bankId,
      this.liftId,
      this.position,
    );
  }

  clone(): AllBanksOutOfServiceResponseT {
    const obj = new AllBanksOutOfServiceResponseT();
    obj.bankName = this.bankName;
    obj.liftName = this.liftName;
    obj.floorName = this.floorName;
    obj.date = this.date;
    obj.availability = this.availability;
    obj.serviceMode = this.serviceMode;
    obj.bankId = this.bankId;
    obj.liftId = this.liftId;
    obj.position = this.position;
    return obj;
  }

  equals(other: AllBanksOutOfServiceResponseT): boolean {
    if (this.bankName !== other.bankName) return false;
    if (this.liftName !== other.liftName) return false;
    if (this.floorName !== other.floorName) return false;
    if (this.date !== other.date) return false;
    if (this.availability !== other.availability) return false;
    if (this.serviceMode !== other.serviceMode) return false;
    if (this.bankId !== other.bankId) return false;
    if (this.liftId !== other.liftId) return false;
    if (this.position !== other.position) return false;
    return true;
  }
}

export function verifyAllBanksOutOfServiceResponse(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    {
      const pos = verifier.checkOffsetField(tablePos, 4);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 8);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    {
      const pos = verifier.checkOffsetField(tablePos, 10);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 10, "date");
    {
      const pos = verifier.checkOffsetField(tablePos, 12);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 12, "availability");
    {
      const pos = verifier.checkOffsetField(tablePos, 14);
      if (pos !== 0) {
        verifier.checkString(pos);
      }
    }
    verifier.checkRequiredField(tablePos, 14, "service_mode");
    verifier.checkScalarField(tablePos, 16, 2);
    verifier.checkScalarField(tablePos, 18, 2);
    verifier.checkScalarField(tablePos, 20, 2);
  } finally {
    verifier.popDepth();
  }
}
